import * as React from 'react';
import { PageHeader, Image, Navbar, Nav, NavItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

import TopBar from './TopBar';
import { inject } from '../../utils/decorators';
import { UiStore } from '../../stores/UiStore';
import ProgressBar from '../site/ProgressBar';
import FaIcon from './FaIcon';

@observer
export default class Header extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;

  render() {

    return (
      <header className="header" role="banner">
        {!this.uiStore.isLoggedIn &&
          <Navbar className="topbar" inverse={true} collapseOnSelect={true} default={true} staticTop={true}>
              <Nav pullRight={true}>
                <NavItem onClick={() => this.uiStore.navigateTo('/login')}>
                  <FaIcon icon="sign-in" /> Login
                </NavItem>
              </Nav>
          </Navbar>
        }
        <ProgressBar />
        <div className="border-bottom">
          <div className="container">
            <PageHeader>
              <Link to="/auftraege"><Image src={require('../../assets/images/logo.png')} className="header-logo" /></Link>
            </PageHeader>
          </div>
        </div>
        {this.uiStore.isLoggedIn && <TopBar />}
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Header.tsx